module.exports = __webpack_public_path__ + "img/preferences_illustration_welcome.47fa6e0a.png";